<template>
    <div :id="'dropdown-tags-'+uniqueId"
         class="dropdown keep-inside-clicks-open dropdown-note-editor d-inline-block">
        <button type="button"
                class="btn p-0"
                :class="[buttonClass, {'disabled': !editable}]"
                data-toggle="dropdown"
                :disabled="!editable"
                :title="$t('manage_tags')">
            <app-icon :name="icon" class="size-18" :class="{'text-muted': !editable}"/>
        </button>
        <div class="dropdown-menu p-primary mt-1">
            <div>
                <p class="text-secondary mb-2">
                    {{ title || $t('manage_tags') }}
                </p>

                <!-- Tags container with yellow background - only shows selected tags -->
                <div class="note note-warning custom-scrollbar p-3 mb-2">
                    <div class="d-flex flex-wrap align-items-center">
                        <!-- Current tags -->
                        <span v-for="tag in selectedTags" :key="tag.id"
                              class="badge badge-primary mr-1 mb-1 d-inline-flex align-items-center">
                            {{ tag[labelField] }}
                            <button type="button" class="btn btn-sm p-0 ml-1 text-white"
                                    @click.stop="removeTagLocal(tag.id)" v-if="editable">
                                <app-icon name="x" class="size-12"/>
                            </button>
                        </span>

                        <!-- Empty state -->
                        <span v-if="!selectedTags.length" class="text-muted">
                            {{ $t('no_tags') }}
                        </span>
                    </div>
                </div>

                <!-- Add tag select - outside yellow area -->
                <div class="mb-3" v-if="editable && availableTags.length">
                    <select class="form-control form-control-sm"
                            @change="addTagLocal($event)">
                        <option value="" selected disabled>+ {{ $t('add') }}</option>
                        <option v-for="tag in availableTags" :key="tag.id" :value="tag.id">
                            {{ tag[labelField] }}
                        </option>
                    </select>
                </div>

                <!-- Footer with Save and Close buttons -->
                <div class="text-right">
                    <a href="#"
                       class="btn btn-secondary btn-sm"
                       @click.prevent="closeDropDown">
                        {{ $t('close') }}
                    </a>
                    <button type="button"
                            class="btn btn-primary btn-sm mr-2"
                            @click="saveTags"
                            :disabled="loading">
                        {{ $t('save') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {axiosGet, axiosPatch} from "../../../common/Helper/AxiosHelper";

export default {
    name: "TagEditor",
    props: {
        // Unique identifier for the dropdown
        uniqueId: {
            type: [String, Number],
            required: true
        },
        // URL to fetch current tags (GET request)
        tagsUrl: {
            type: String,
            required: true
        },
        // URL to update tags (PATCH request with {tag_ids: []})
        updateUrl: {
            type: String,
            required: true
        },
        // URL to fetch all available tags for selection
        allTagsUrl: {
            type: String,
            required: true
        },
        // Field name to display as tag label
        labelField: {
            type: String,
            default: 'title'
        },
        // Title for dropdown header
        title: {
            type: String,
            default: ''
        },
        // Icon name
        icon: {
            type: String,
            default: 'tag'
        },
        // Button CSS class
        buttonClass: {
            type: String,
            default: 'primary-text-color'
        },
        // Allow editing (add/remove)
        editable: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            selectedTags: [],  // Local copy for editing
            allTags: [],
            loading: false
        }
    },

    computed: {
        availableTags() {
            const selectedIds = this.selectedTags.map(t => t.id);
            return this.allTags.filter(t => !selectedIds.includes(t.id));
        }
    },

    created() {
        this.loadTags();
        this.loadAllTags();
    },

    mounted() {
        // Reload tags when dropdown opens to reset any unsaved changes
        $(`#dropdown-tags-${this.uniqueId}`).on('show.bs.dropdown', () => {
            this.loadTags();
        });
    },

    methods: {
        loadTags() {
            axiosGet(this.tagsUrl).then(({data}) => {
                this.selectedTags = [...data];
            });
        },

        loadAllTags() {
            axiosGet(this.allTagsUrl).then(({data}) => {
                this.allTags = data;
            });
        },

        // Add tag locally (UI only, not saved yet)
        addTagLocal(event) {
            const tagId = parseInt(event.target.value);
            if (!tagId) return;

            event.target.value = ''; // Reset select

            const tag = this.allTags.find(t => t.id === tagId);
            if (tag && !this.selectedTags.find(t => t.id === tagId)) {
                this.selectedTags.push(tag);
            }
        },

        // Remove tag locally (UI only, not saved yet)
        removeTagLocal(tagId) {
            this.selectedTags = this.selectedTags.filter(t => t.id !== tagId);
        },

        // Save to server when clicking Save button
        saveTags() {
            this.loading = true;
            const tagIds = this.selectedTags.map(t => t.id);

            axiosPatch(this.updateUrl, {
                tag_ids: tagIds
            }).then(() => {
                this.$toastr.s('', this.$t('tags_updated_successfully'));
                this.$emit('updated');
                this.closeDropDown();
            }).catch(() => {
                this.$toastr.e('', this.$t('error'));
            }).finally(() => {
                this.loading = false;
            });
        },

        closeDropDown() {
            $(".dropdown-menu").removeClass('show');
        }
    }
}
</script>

<style scoped lang="scss">
.dropdown {
    .dropdown-menu {
        width: 350px;

        .note {
            overflow-y: auto;
            max-height: 150px;
        }
    }

    .badge {
        font-size: 12px;
    }
}
</style>
